import React, {
  useEffect,
  useState
} from 'react'
import {
  Popup,
  Responsive
} from 'semantic-ui-react'
import reduce from 'lodash/reduce'
// Local
import {
  API_URL,
  MOBILE_WIDTH,
  REVIEW,
  TABLET_WIDTH
} from '../../constant'
import { api } from '../../action/api'

/**
 * Provides a component that displays the Coder user review count for the current
 * day. Count includes reviews marked READY_FOR_CODER_QA and COMPLETED
 * Requires no properties.
 */
function CoderCounter() {
  const [
    reviewCountState,
    setreviewCountState
  ] = useState<number>(0)

  const [
    readyForCoderQaState,
    setreadyForCoderQaState
  ] = useState<number>(0)

  const [
    completedState,
    setCompletedState
  ] = useState<number>(0)

  const reduceReviewCounts = (
    reviewCounts: any[] | null | undefined,
    reviewCode: string
  ) => reduce(reviewCounts, (result, row) => {
    if (row.reviewCode === reviewCode) {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return result + row.reviewCount
    }
    return result
  }, 0)


  const fetchReviewCount = () => {
    const url = API_URL.REVIEW_COUNT
    api.get(url).then(({ data }) => {
      const coderQaCount = reduceReviewCounts(
        data as any[],
        REVIEW.CODE.READY_FOR_CODER_QA
      )
      const completedCount = reduceReviewCounts(
        data as any[],
        REVIEW.CODE.COMPLETED
      )
      const total = coderQaCount + completedCount
      setreviewCountState(total)
      setreadyForCoderQaState(coderQaCount)
      setCompletedState(completedCount)
    })
  }

  useEffect(() => {
    fetchReviewCount()
  }, [])

  const counterMessage = () => {
    const msgs = []
    if (completedState > 0) {
      msgs.push(`Completed: ${completedState}`)
    }
    if (readyForCoderQaState > 0) {
      msgs.push(`; Ready for Coder QA: ${readyForCoderQaState}`)
    }
    if (reviewCountState === 0) {
      msgs.push('Completed: 0; Ready for Coder QA: 0')
    }
    return msgs.join('; ')
  }

  const msg = counterMessage()

  return (
    <span>
      <Responsive
        minWidth={ TABLET_WIDTH.minWidth }
        className="bold"
      >
        <Popup
          content={ msg }
          mouseEnterDelay={ 1000 }
          trigger={
            <span>
              Reviewed: { reviewCountState }
            </span>
          }
        />
      </Responsive>
      <Responsive
        maxWidth={ MOBILE_WIDTH.maxWidth }
        className="bold"
      >
        { reviewCountState }
      </Responsive>
    </span>
  )
}

export default CoderCounter
